import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import SnackbarProvider from "./components/snackbar/SnackbarProvider";
import { StoreNotFoundPage } from "@ecommerce/ui-core";

import {
    initAnalyticsFromApi,
    initMetricTracker,
    refreshEnabledMetrics,
} from "@ecommerce/analytics";
import { HttpAxiosRequest, httpClient } from "./http";
import { TiendaNoEncontradaError } from "./http/httpTiendaTemplate";
import { aplicarTemplateTheme } from "./templates/aplicarTemplateTheme";
import {
    cargarTemplateConfigInicial,
    type TemplateConfigInicial,
} from "./templates/templateConfigLoader";
import { TemplateConfigProvider } from "./templates/templateConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

(async () => {
    let configInicial: TemplateConfigInicial;
    try {
        configInicial = await cargarTemplateConfigInicial();
    } catch (error) {
        if (error instanceof TiendaNoEncontradaError) {
            root.render(
                <React.StrictMode>
                    <StoreNotFoundPage />
                </React.StrictMode>,
            );
            return;
        }
        throw error;
    }

    aplicarTemplateTheme(configInicial.config);

    root.render(
        <React.StrictMode>
            <TemplateConfigProvider configInicial={configInicial}>
                <SnackbarProvider>
                    <App />
                </SnackbarProvider>
            </TemplateConfigProvider>
        </React.StrictMode>,
    );

    void initAnalyticsFromApi(HttpAxiosRequest);
    void initMetricTracker(httpClient);

    const refreshMetricsWhenReturning = () => {
        if (document.visibilityState === "visible") void refreshEnabledMetrics();
    };

    window.addEventListener("focus", refreshMetricsWhenReturning);
    document.addEventListener("visibilitychange", refreshMetricsWhenReturning);
})();
